import React from 'react';
import TrackingIcon from '../../TransportPopup/Transport/TrackingIcon';

export default function TrackingStatusCell({ value: trackingStatus }) {
  return (
    <TrackingIcon centered padding={{ size: 'xs' }} trackingStatus={trackingStatus} />
  );
}
